<script setup>
defineProps({
    title: {
        type: String,
        default: null
    }
})

</script>

<template>
    <v-card border tabindex="0">
        <template #title>
            <h3>{{ title }}</h3>
        </template>
        <v-card-item>
            <slot/>
        </v-card-item>
    </v-card>
</template>

<style scoped>
.v-card {
    background-color: white;
    border: 2px rgb(var(--v-theme-primary)) solid;
}
</style>
